import { axiosSwagger } from "@/axios";



export const state = {
    posted: {
        loading: false,
        data: [],
        total: 0,
    }

}


export const getters = {
}


export const mutations = {
    loading: (state, loading) => {
        state.posted.loading = loading;
    },
    setData: (state, data) => {
        state.posted.data = modifyData( data );
    },
    setTotal: (state, total) => {
        state.posted.total = total;
    },
    remove: (state, id) => {
        state.posted.data = state.posted.data.filter((el) => el.id !== id);
    },
}


export const actions = {
    // FILE POSTED
    async readFilePostedByDeliveryUnitId({ commit }) {
        commit("loading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FilePosting/Approved/DeliveryUnitId/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    }
}

const checkIsClassified = (e) => {
    if(e ?? false){
      // e filter data if classified and if user is not the one who upload
      const isClassified = e?.isClassified || false;
      const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
      
      return isClassified && e?.applicationUserId !== userData?.userId;
    }
}

// eslint-disable-next-line no-unused-vars
const modifyData = (arrayData) => {
    if(arrayData?.length ?? false){
        arrayData.forEach(e => {
            const isClassifiedDoc = checkIsClassified(e);

            e.isClassifiedDoc = isClassifiedDoc;
            e.fileManager.isClassifiedDoc = isClassifiedDoc;
        });
        
        return arrayData
    }
  
    return [];
};